import React from "react";
import { type DropdownProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const ProductGroupDropdown = (props: DropdownProps<server.dto.ProductGroup>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={props.options}
    getLabel={p => p.title}
    getValue={(t) => t.productGroupId}
    value={props.value}
    onChange={props.onChange}
    config={{
      isSearchable: true,
      ...props.config
    }}
  />;
};

export default ProductGroupDropdown;